import Vue from 'vue'
import Router from 'vue-router'
import Loading from '@/components/Loading'
import Popup from '@/components/Popup'
import IndexPage from '@/components/IndexPage'
import UserEditModal from '@/components/UserEditModal'

import Menu from '@/components/Menu'
import Mobile_Menu from '@/components/Mobile_Menu'
import Mobile_SearchMain from '@/components/Mobile_SearchMain'

import LogPage from '@/components/LogPage'
import LogMain from '@/components/LogMain'

import StoragePage from '@/components/StoragePage'
import StorageMain from '@/components/StorageMain'

import SearchPage from '@/components/SearchPage'
import SearchMain from '@/components/SearchMain'

import OrderPage from '@/components/OrderPage'
import OrderMain from '@/components/OrderMain'
import OrderModal_New from '@/components/OrderModal_New'
import OrderModal_Add from '@/components/OrderModal_Add'
import OrderModal_Edit from '@/components/OrderModal_Edit'
import OrderModal_Confirm from '@/components/OrderModal_Confirm'
import OrderModal_Detail from '@/components/OrderModal_Detail'
import OrderModal_Detail2 from '@/components/OrderModal_Detail2'

import ParcelOrderPage from '@/components/ParcelOrderPage'
import ParcelOrderMain from '@/components/ParcelOrderMain'
import ParcelOrderModal_New from '@/components/ParcelOrderModal_New'
import ParcelOrderModal_Add from '@/components/ParcelOrderModal_Add'
import ParcelOrderModal_Detail from '@/components/ParcelOrderModal_Detail'

import ParcelItemPage from '@/components/ParcelItemPage'
import ParcelItemMain from '@/components/ParcelItemMain'
import ParcelItemModal_Detail from '@/components/ParcelItemModal_Detail'

import OrderedItemPage from '@/components/OrderedItemPage'
import OrderedItemMain from '@/components/OrderedItemMain'
import OrderedItemModal_Detail from '@/components/OrderedItemModal_Detail'
import CompleteItemPage from '@/components/CompleteItemPage'
import CompleteItemMain from '@/components/CompleteItemMain'
import CanceledItemPage from '@/components/CanceledItemPage'
import CanceledItemMain from '@/components/CanceledItemMain'
import FinishedItemModal_Detail from '@/components/FinishedItemModal_Detail'
import PhotoModal from '@/components/PhotoModal'

import PartnerPage from '@/components/PartnerPage'
import PartnerMain from '@/components/PartnerMain'
import PartnerModal from '@/components/PartnerModal'
import PartnerModal_Calculate from '@/components/PartnerModal_Calculate'

import ProductPage from '@/components/ProductPage'
import ProductMain from '@/components/ProductMain'
import ProductModal_Edit from '@/components/ProductModal_Edit'
import ProductModal_DailyLog from '@/components/ProductModal_DailyLog'
import ProductModal_Counter from '@/components/ProductModal_Counter'

import StockPage from '@/components/StockPage'
import StockMain from '@/components/StockMain'
import StockModal_New from '@/components/StockModal_New'
import StockModal_Detail from '@/components/StockModal_Detail'
import StockModal_Set from '@/components/StockModal_Set'
import StockModal_Transfer from '@/components/StockModal_Transfer'
import StockModal_DailyLog from '@/components/StockModal_DailyLog'

import CenterPage from '@/components/CenterPage'
import CenterMain from '@/components/CenterMain'
import CenterModal_Edit from '@/components/CenterModal_Edit'
import CenterModal_Calculate from '@/components/CenterModal_Calculate'

import WorkerModal_List from '@/components/WorkerModal_List'
import WorkerModal_Edit from '@/components/WorkerModal_Edit'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: IndexPage,
    },
    {
      path: '/search',
      component: SearchPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: SearchMain,
            loading: Loading,
            user_edit: UserEditModal,
            orderedItem_detail: OrderedItemModal_Detail,
            finishedItem_detail: FinishedItemModal_Detail,
            parcelItem_detail: ParcelItemModal_Detail,
            photo: PhotoModal,
            mobile_nav: Mobile_Menu,
            mobile_main: Mobile_SearchMain,
          }
        }
      ]
    },
    {
      path: '/order',
      component: OrderPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: OrderMain,
            order_new: OrderModal_New,
            order_add: OrderModal_Add,
            order_edit: OrderModal_Edit,
            order_confirm: OrderModal_Confirm,
            order_detail: OrderModal_Detail,
            order_detail2: OrderModal_Detail2,
            loading: Loading,
            popup: Popup,
            user_edit: UserEditModal,
            orderedItem_detail: OrderedItemModal_Detail,
            finishedItem_detail: FinishedItemModal_Detail,
            photo: PhotoModal,
          }
        }
      ]
    },
    {
      path: '/parcelOrder',
      component: ParcelOrderPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: ParcelOrderMain,
            modal_new: ParcelOrderModal_New,
            modal_add: ParcelOrderModal_Add,
            modal_detail: ParcelOrderModal_Detail,
            loading: Loading,
            popup: Popup,
            user_edit: UserEditModal,
          }
        }
      ]
    },
    {
      path: '/orderedItem',
      component: OrderedItemPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: OrderedItemMain,
            loading: Loading,
            popup: Popup,
            photo: PhotoModal,
            user_edit: UserEditModal,
            item_detail: OrderedItemModal_Detail,
            product_counter: ProductModal_Counter,
            worker_list: WorkerModal_List,
            worker_edit: WorkerModal_Edit,
          }
        }
      ]
    },
    {
      path: '/completeItem',
      component: CompleteItemPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: CompleteItemMain,
            loading: Loading,
            user_edit: UserEditModal,
            item_detail: FinishedItemModal_Detail,
            product_counter: ProductModal_Counter,
            photo: PhotoModal,
            popup: Popup,
            worker_list: WorkerModal_List,
            worker_edit: WorkerModal_Edit,
          }
        }
      ]
    },
    {
      path: '/canceledItem',
      component: CanceledItemPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: CanceledItemMain,
            loading: Loading,
            user_edit: UserEditModal,
            item_detail: FinishedItemModal_Detail,
            product_counter: ProductModal_Counter,
            popup: Popup,
            worker_list: WorkerModal_List,
            worker_edit: WorkerModal_Edit,
          }
        }
      ]
    },
    {
      path: '/parcelItem',
      component: ParcelItemPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: ParcelItemMain,
            modal_detail: ParcelItemModal_Detail,
            loading: Loading,
            user_edit: UserEditModal,
            product_counter: ProductModal_Counter,
          }
        }
      ]
    },
    {
      path: '/product',
      component: ProductPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: ProductMain,
            modal_edit: ProductModal_Edit,
            modal_log: ProductModal_DailyLog,
            stock_set: StockModal_Set,
            stock_transfer: StockModal_Transfer,
            popup: Popup,
            loading: Loading,
          }
        }
      ],
    },
    {
      path: '/partner',
      component: PartnerPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: PartnerMain,
            modal: PartnerModal,
            modal_calculate: PartnerModal_Calculate,
            user_edit: UserEditModal,
            loading: Loading,
          }
        }
      ]
    },
    {
      path: '/center',
      component: CenterPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: CenterMain,
            modal_edit: CenterModal_Edit,
            modal_calculate: CenterModal_Calculate,
            worker_list: WorkerModal_List,
            worker_edit: WorkerModal_Edit,
            user_edit: UserEditModal,
            popup: Popup,
            loading: Loading,
          }
        }
      ]
    },
    {
      path: '/stock',
      component: StockPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: StockMain,
            modal_new: StockModal_New,
            modal_detail: StockModal_Detail,
            modal_daily: StockModal_DailyLog,
            user_edit: UserEditModal,
            popup: Popup,
            loading: Loading,
          }
        }
      ]
    },
    {
      path: '/log',
      component: LogPage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: LogMain,
            loading: Loading,
            user_edit: UserEditModal,
          }
        }
      ]
    },
    {
      path: '/storage',
      component: StoragePage,
      children: [
        {
          path: 'index',
          components: {
            nav: Menu,
            main: StorageMain,
            loading: Loading,
            user_edit: UserEditModal,
          }
        }
      ]
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js